module.exports = __webpack_public_path__ + "static/media/Commercial-5.7a138f98.jpg";